// Copied from advisor-3.0/src/components/Helpers/Formatters/StringToPhoneNumber.js
export default function GetFormattedNumber(phone: string | null | undefined): string {
  if (!phone) {
    return '';
  }
  const phoneNumber = String(phone);
  const phoneNumberString = phoneNumber.replaceAll('-', '').replace('(', '').replaceAll(' ', '').replace(')', '');
  const firstPart = phoneNumberString.substring(0, 3);
  const secondPart = phoneNumberString.substring(3, 6);
  const lastPart = phoneNumberString.substring(6, 10);
  return `(${firstPart}) ${secondPart}-${lastPart}`;
}
